"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Check;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Check(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Arrows_",
    "data-name": "Arrows+"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "check"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-4",
    "data-name": "outline",
    d: "M35.961,79.271a3.663,3.663,0,0,1-2.61-1.08L8.232,53.072a2.5,2.5,0,0,1,3.536-3.535L35.961,73.73,88.232,21.461A2.5,2.5,0,1,1,91.768,25l-53.2,53.2A3.658,3.658,0,0,1,35.961,79.271Z"
  }))));
}